"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrency = void 0;
const react_1 = require("react");
const LocalizationContext_1 = require("../context/LocalizationContext");
// на втором этапе доработаю (это интерфейс для работы с данным контекстом)
const useCurrency = () => {
    const { state } = (0, react_1.useContext)(LocalizationContext_1.LocalizationContext);
    return {
        code: state.currency.code,
        symbol: state.currency.symbol,
    };
};
exports.useCurrency = useCurrency;
